"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = __importDefault(require("../../"));
/**
 * The eBay  Notification API allows third-party developers and applications to process eBay notifications and verify the integrity of the notification message payload.
 */
class Notification extends __1.default {
    get basePath() {
        return '/commerce/notification/v1';
    }
    /**
     * This method allows users to retrieve a public key using a specified key ID.
     *
     * @param publicKeyId The unique key ID that is used to retrieve the public key
     */
    getPublicKey(publicKeyId) {
        publicKeyId = encodeURIComponent(publicKeyId);
        return this.get(`/public_key/${publicKeyId}`);
    }
}
exports.default = Notification;
Notification.id = 'Notification';
//# sourceMappingURL=index.js.map